<template>
  <div class="mx-auto px-4 bg-white h-screen">
    <div class="px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.class_list')}} {{getClassName($route)}}</Header>
      <div class="pb-4 flex">
        <div
          class="pl-5"
          @click="goToCommunication"
        >
          <span class="p-1 px-2 rounded-full text-xs bg-blue text-white shadow-custom">
            <i class="fa fa-envelope"></i>
            <span class="pl-3"> {{ unreadEmails }}</span>
          </span>
        </div>
      </div>
      <GenitoreClasse v-if="showContact(classe)"
        v-for="classe in genitoriClassi"
        :showContact="showContact(classe)"
        :classe="classe"
        :key="classe.id"
      >
      </GenitoreClasse>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import parseInt from 'lodash/parseInt';

export default {
  props: ['id'],
  data() {
    return {
      unreadMessages: 0,
    };
  },
  computed: {
    ...mapGetters({
      inboxCount: 'communication/inboxCount',
      roomId: 'classi/roomId',
      userId: 'classi/userId',
      getClassName: 'users/getClassName',
      genitoriClassi: 'users/classroomParents',
    }),
    displayUnreadMessages() {
      return this.unreadMessages < 10 ? this.unreadMessages : '9+';
    },
    unreadEmails() {
      return !this.inboxCount
        ? 0
        : this.inboxCount <= 9
        ? this.inboxCount
        : '9+';
    },
  },
  methods: {
    ...mapActions('classi', []),
    ...mapActions('users', ['getMinor', 'showClassroomParents']),
    ...mapActions('communication', ['getCommunicationTutorCount']),
    showContact(classe) {
      let result = true;
      for (let j = 0; j < classe.admin_tutors.length; j += 1) {
        if (!classe.admin_tutors[j].show_contacts) {
          result = result && false;
        }
      }
      return result;
    },
    goToCommunication() {
      this.$router.push({
        name: 'Communication',
        params: { id: this.$route.params.id },
        query: { classe: this.$route.query.classe },
      });
    },
  },
  async created() {
    const self = this;
    const role = authService.getRole();

    await self.getMinor({ id: self.id, role });
    self.getCommunicationTutorCount({ minorId: self.id });
    self.showClassroomParents({
      id: self.id,
      classroom: parseInt(self.$route.query.classe),
    });
  },
};
</script>
